<template>
	<div>
		<van-nav-bar title="天气播报" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">


			<van-field v-model="city" name="city" label="地区:" placeholder="如:厦门" :rules="[{ required: true, message: '播报地区' }]"
			 maxlength="5" />
			 
			 <van-field @click="showTimeSelect" v-model="current_time" name="current_time" readonly label="播报时间:" placeholder="选择时间" />

			<van-popup v-model="show_time_select" round :style="{ height: '50%', width: '95%' }">
				<van-datetime-picker @confirm="onChange" @cancel="onCancel" v-model="current_time" type="time" titlle="选择时间" :min-hour="5" :max-hour="10" />
			</van-popup>
			
			<van-field name="switch_checked" label="是否开启">
				<template #input>
					<van-switch v-model="switch_checked" size="20" />
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	import Vue from 'vue';
	import {
		DatetimePicker
	} from 'vant';

	Vue.use(DatetimePicker);
	export default {
		data() {
			return {
				group_id: 0,
				show_time_select: false,
				
				switch_checked: false,
				op: 'weather',

				city: '',
				current_time: '',

			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.city = res.data.city
					this.current_time = res.data.current_time
					this.switch_checked = res.data.switch_checked
				}
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
						return
					}
					this.$toast.success('已保存')
				})
			},
			onChange(e){
				this.show_time_select = false
			},
			onCancel(){
				this.show_time_select = false
			},
			showTimeSelect(){
				this.show_time_select = true
			}
		}
	}
</script>

<style>
</style>
